import ErrorWrapper from "components/ErrorWrapper"
import Exoskeleton from "components/Exoskeleton"
import useAdminUser from "components/hooks/useAdminUser"
import React, { createContext } from "react"
import { useLDClient } from "launchdarkly-react-client-sdk"

export const UserContext = createContext({ adminUser: null })
export const UserProvider = ({ children }): JSX.Element => {
  const { data: adminUser, isLoading, error } = useAdminUser()
  const ldClient = useLDClient()

  if (!isLoading && !error && ldClient) {
    ldClient.identify({ key: adminUser?.email, email: adminUser?.email })
  }

  return (
    <ErrorWrapper error={error}>
      <Exoskeleton isLoading={isLoading}>
        {isLoading ? null : <UserContext.Provider value={{ adminUser }}>{children}</UserContext.Provider>}
      </Exoskeleton>
    </ErrorWrapper>
  )
}
